import React, { ReactNode } from "react";

interface AppTableHeadProps extends React.HTMLAttributes<HTMLTableSectionElement> {
  children: ReactNode;
  className?: string;
}

const AppTableHead: React.FC<AppTableHeadProps> = ({ children, className = "", ...props }) => {
  return (
    <thead className={`bg-gray-200 sticky top-0 z-20 ${className}`} {...props}>
      {children}
    </thead>
  );
};

export default AppTableHead;